import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  exportSalesReport,
  getCustomerList,
  getSalesReportData,
  selectSalesReport,
  setCustomers,
  setTotalAmount,
} from "./store/salesReportSlice";
import withReducer from "../../../store/withReducer";
import reportReducer from "../index";
import { getSellerSettings, setSettings } from "../../seller/store/sellerSlice";
import Select from "react-select";
import moment from "moment";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import { DateRangePicker } from "rsuite";
import AsyncSelect from "react-select/async";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { customerAutoSuggestionApi } from "../../../services/order";
import { sellerAutoSuggestionApi } from "../../../services/manage-product/productService";
import SalesStats from "./content/salesStats";
import PreLoader from "../../../share-components/ui/preLoader";

const { afterToday } = DateRangePicker;
const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
    backgroundColor: 'rgba(211, 211, 211, 0.11)',
    borderRadius: 12
    // borderColor: '#d3d3d3',
    // '&:hover': {
    //   borderColor: '#c0c0c0', 
    // },
  }),
};

const dataMenu = [
  {
    type: 0,
    text: "Sales Report",
  },
];

const tableColumns = [
  {
    name: "#",
    selector: (row) => row.order,
    sortable: true,
    center: false,
  },
  {
    name: "Date",
    selector: (row) => row.date,
    sortable: true,
    left: true,
  },
  {
    name: "Customer",
    selector: (row) => row.customer,
    sortable: true,
    left: true,
  },
  {
    name: "Qty",
    selector: (row) => row.itm_qty,
    sortable: true,
    right: true,
  },
  {
    name: "Price (£)",
    selector: (row) => row.price,
    sortable: true,
    right: true,
  },
  {
    name: "Return Qty",
    selector: (row) => row.return_qty,
    sortable: true,
    right: true,
  },
  {
    name: "Return Price (£)",
    selector: (row) => row.return_val,
    sortable: true,
    right: true,
  },
];

const SalesReport = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const start_date = queryParams.get("start_date");
  const end_date = queryParams.get("end_date");

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, isSetLoading] = useState(false);
  const [tableLoading, isSetTableLoading] = useState(false);
  const salesReportState = useSelector(({ report }) => report.salesReport);
  const salesReport = useSelector(selectSalesReport);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 30);
  const [pageSize, setPageSize] = useState(10);
  const sellerState = useSelector(({ seller }) => seller.seller);
  const [exportBtnDisabled, setExportBtnDisabled] = useState(false);
  // const backInRequestState = useSelector(({backStore}) => backStore.backStoreRequest)

  const [agent, setAgent] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [seller, setSeller] = useState(null);
  const [partner, setPartner] = useState(null);

  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);

  const [startDate, endDate] = dateRange;
  const [filter, setFilter] = useState({
    start_date: moment(startDate).format("YYYY-MM-DD"),
    end_date: moment(endDate).format("YYYY-MM-DD"),
    customer: null,
    seller: null,
    partner: null,
    agent : null
  });

  useEffect(() => {
    getData();
  }, [customer, startDate, endDate, agent, page, pageSize,seller,partner, dispatch]);

  useEffect(() => {
      setFilter(prev => ({
          ...prev,
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
          customer: customer ? customer?.value : null,
          seller: seller ? seller?.value : null,
          partner: partner ? partner?.id : null,
          agent

      }));
  }, [startDate, endDate, customer, seller, partner, agent])

  const pagination = (e) => {
    setPageSize(e);
  };

  const getData = () => {
    if (startDate !== null && endDate !== null) {
      isSetTableLoading(true);
      isSetLoading(true);
      const data = {
        customer: customer ? customer?.value : null,
        seller: seller ? seller?.value : null,
        partner: partner ? partner?.id : null,
        page: page,
        pageSize: pageSize,
        agent,
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
      };
      dispatch(getSalesReportData(data)).then((res) => {
        isSetLoading(false);
        isSetTableLoading(false);
      });
    }
  };

  useEffect(() => {
    dispatch(getSellerSettings()).then((res) => {
      if (!res.error) {
        const results={
            settings:res.payload,
            id:null
        }
        dispatch(setSettings(results));
      }
    });
  }, [dispatch]);

  const customerPromiseOption = (inputValue) =>
    new Promise((resolve) => {
        const data = {
            value: inputValue
        }
        setTimeout(() => {
            resolve(mapSearchAutoSuggestion(customerAutoSuggestionApi(data)))
        });
  });

  const sellerPromiseOption = (inputValue) =>
    new Promise((resolve) => {
        const data = {
            value: inputValue
        }
        setTimeout(() => {
            resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)))
        });
  });

  const exportFile = () => {
    if (exportBtnDisabled) return;
    setExportBtnDisabled(true);

    dispatch(
        exportSalesReport(filter)
    ).then((res) => {
        const link = document.createElement("a");
        link.href = res.payload;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
        setExportBtnDisabled(false);
    });
  }

  return (
    <Fragment>
          <Breadcrumb title="Sales Report" data={dataMenu} />
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid">
              <div className="feature-products">

                <Card className="mb-0">
                  <CardBody className="p-3">
                    <Row className="align-items-center">
                      <Col>
                        <div className="dashboard-datepicker">
                          <DatePicker
                            dateRange={dateRange}
                            dateRangeChange={(date) => {
                              setDateRange(date);
                            }}
                            defaultValue={[TodayDate, sevenDays]}
                            disabledDate={afterToday()}
                            paddingLeft={0}
                          />
                        </div>
                        
                      </Col>
                      <Col>
                        <Select
                          placeholder="Agent/Sales Person"
                          className="select2-filter"
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          isClearable
                          cacheOptions
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          styles={customStyles}
                          options={sellerState.settings.agents}
                          onChange={(e) => {
                            console.log(e);
                            setAgent(e ? e.id : null);
                          }}
                        />
                      </Col>
                      <Col>
                        <AsyncSelect
                            className="select2-filter"
                            isClearable={true}
                            menuPortalTarget={document.body}
                            defaultOptions
                            placeholder="Select Seller"
                            loadOptions={sellerPromiseOption}
                            styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            onClear={(e) => {
                        
                            }}
                            value={seller}
                            onChange={(e) => {
                                setSeller(e ? e : null); 
                            }}  
                          />
                      </Col>
                      <Col>
                      <Select
                          placeholder="Select Partner"
                          className="select2-filter"
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          isClearable
                          cacheOptions
                          styles={customStyles}
                          defaultValue={partner}
                          options={sellerState.settings.partner}
                          onChange={(e) => {
                              setPartner(e ? e : null);
                          }}
                          components={{
                              IndicatorSeparator: () => null
                          }}
                      />
                      </Col>
                      <Col>
                        <AsyncSelect
                            className="select2-filter"
                            isClearable={true}
                            cacheOptions
                            defaultOptions
                            placeholder="Customer"
                            loadOptions={customerPromiseOption}
                            value={customer}
                            styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            onClear={(e) => {

                            }}
                            onChange={(e) => {
                                setCustomer(e ? e : null);
                            }}
                        />
                      </Col>
                      <Col className="d-flex align-items-center justify-content-end">
                        <div >
                            <Button
                                type="button"
                                color="primary"
                                onClick={() => {
                                    exportFile();
                                }}
                                disabled={exportBtnDisabled}
                            >
                                <i className={exportBtnDisabled ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                                Export Report
                            </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                
                {tableLoading ? <div style={{minHeight: 150}}><PreLoader/></div>  :
                <>
                
                <SalesStats summary={salesReportState.summary}/>
                <Row>
                  <Col className="mt-4" sm="12">
                    <Card>
                      <CardBody>
                        <div className="table-responsive product-table">
                          <CommonDataTable
                            headerColumns={tableColumns}
                            gridData={salesReport}
                            paginationServer
                            paginationTotalRows={
                              salesReportState.salesReportTableRow
                            }
                            noAction
                            onChangePage={(page) => setPage(page)}
                            onChangeRowsPerPage={pagination}
                          />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                </> }
              </div>
            </div>
          </Container>
    </Fragment>
  );
};

export default withReducer([{ report: reportReducer }])(SalesReport);
